import {v1_Report_Roles_select_column} from '../../generated/types';

const ReportsToRoles = {
    ...v1_Report_Roles_select_column,
    res: 'v1_Report_Roles',
    comp: {},
    rel: {},
};

export default ReportsToRoles;
